<app-ai-document-processing-loading [matterDocumentType]="documentType()">
	<div class="h-full overflow-y-auto">
		<app-container
			type="dark"
			class="flex flex-1 h-full justify-center items-center"
			*ngIf="!(commissionStatement$ | async)?.url"
			[testHook]="testHooks.Container"
		>
			<app-ai-scraping-notification uiCardClass="p-2" />
			<div class="flex flex-1 h-full justify-center items-center">
				<app-sale-file-upload
					class="flex-none"
					type="dropzone"
					label="Upload commission statement"
					[preventDuplicateUpload]="true"
					[saleId]="matterId$ | async"
					[documentName]="documentName$ | async"
					[documentType]="documentType()"
					(success)="onCommissionStatementUpload($event)"
				></app-sale-file-upload>
			</div>
		</app-container>
		<div class="h-full" *ngIf="(commissionStatement$ | async)?.url">
			<app-matter-url-pdf-viewer
				[googleSrcUrl]="(commissionStatement$ | async)?.url"
				[fileName]="(commissionStatement$ | async)?.name"
				[fileType]="(commissionStatement$ | async)?.fileType"
				[showDelete]="true"
				(delete)="deleteCommissionStatement()"
			></app-matter-url-pdf-viewer>
		</div>
	</div>
</app-ai-document-processing-loading>
